import LoanContext from '@containers/Loan/LoanStore';
import ReturnContext from '@containers/Return/ReturnStore';
import PayOffContext from '@containers/PayOff/PayOffStore';
import TrialBalanceContext from '@containers/TrialBalance/TrialBalanceStore';
import HomeContext from '@containers/Home/HomeStore';
import LayoutContext from './LayoutStore';
import AuthContext from './AuthStore';
import AccountingContext from '@containers/Accounting/AccountingStore';
import BankStatementContext from '@containers/Accounting/components/BankStatement/BankStatementStore';
import CollateralDetailContext from '@containers/Accounting/components/CollateralDetail/CollateralDetailStore';
import LoanDetailContext from '@containers/Accounting/components/LoanDetail/LoanDetailStore';
import PayoffDetailContext from '@containers/Accounting/components/PayoffDetail/PayoffDetailStore';
import React, { createContext, useContext } from 'react';
export const RootStoreContext = createContext(null);
export const useStore = () => useContext(RootStoreContext);
const RootStore = ({ children }) => {
    const LayoutStore = LayoutContext();
    const AuthStore = AuthContext();
    const LoanStore = LoanContext();
    const ReturnStore = ReturnContext();
    const PayOffStore = PayOffContext();
    const TrialBalanceStore = TrialBalanceContext();
    const HomeStore = HomeContext();
    const AccountingStore = AccountingContext();
    const BankStatementStore = BankStatementContext();
    const CollateralDetailStore = CollateralDetailContext();
    const LoanDetailStore = LoanDetailContext();
    const PayoffDetailStore = PayoffDetailContext();

    return (
        <RootStoreContext.Provider
            value={{
                LayoutStore,
                AuthStore,
                LoanStore,
                ReturnStore,
                PayOffStore,
                TrialBalanceStore,
                HomeStore,
                AccountingStore,
                BankStatementStore,
                CollateralDetailStore,
                LoanDetailStore,
                PayoffDetailStore,
            }}
        >
            {children}
        </RootStoreContext.Provider>
    );
};
export default RootStore;
